import React from "react";

export const CustomInputText = (props) => {

    const { type, label, placeholder, error, onChange, value, disabled, helperText, style } = props;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15, flex: '1 1 0' }}>
           { label && <label style={{ fontWeight: 600, fontSize: 14, ...style }} htmlFor="input">{ label }</label> }
            <input style={
                error ? { borderRadius: 4, border: '1px solid #d32f2f', padding: 10 }
                      : { borderRadius: 4, border: '1px solid #bdbdbd', padding: 10 }
            } id='input' type={ type }  placeholder={ placeholder } onChange={ onChange } value={ value } disabled={ disabled } />
            {
                helperText && (
                    <span 
                        style={
                            error ? { fontSize: 12, color: '#d32f2f', marginLeft: 5 }
                                : { fontSize: 12, color: 'rgba(0,0,0,.6)', marginLeft: 5 }
                        }>{ error && error?.message }</span>
                )
            }
        </div>
    )
};

CustomInputText.defaultProps = {
    type: 'text',
    label: '',
    placeholder: '',
    error: null,
    onChange: () => false,
    value: '',
    disabled: false,
    helperText: true,
    style: {}
}